import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { PATTERNS } from "../../common/Constants";
import { componentTypes } from "../../common/FormRenderer"
import { preventDefault } from "../../../utils/common";

export const LOGIN_FIELDS = {
    USERNAME: {
        component: componentTypes.TEXT_FIELD,
        name: 'username',
        label: 'Username',
        fieldType: 'email',
        validate: [
            { type: validatorTypes.REQUIRED }
        ]
    },
    PASSWORD: {
        component: componentTypes.TEXT_FIELD,
        name: 'password',
        label: 'Password',
        fieldType: 'password',
        validate: [
            { type: validatorTypes.REQUIRED },
            { type: validatorTypes.MIN_LENGTH, threshold: 12 },
            { type: validatorTypes.MAX_LENGTH, threshold: 128 }
        ]
    },
    OTP: {
        component: componentTypes.TEXT_FIELD,
        name: 'otp',
        fieldType: 'number',
        styleClass: 'p-2 fw-bold letter-spacing-2',
        validate: [
            { type: validatorTypes.REQUIRED },
            { type: validatorTypes.MAX_LENGTH, threshold: 6 }
        ]
    },
    NEW_PASSWORD: {
        component: componentTypes.TEXT_FIELD,
        name: 'newPassword',
        label: 'New Password',
        fieldType: 'password',
        validate: [
            { type: validatorTypes.REQUIRED },
            { type: validatorTypes.PATTERN, pattern: PATTERNS.PASSWORD, message: 'Invalid New Password' },
            { type: validatorTypes.MIN_LENGTH, threshold: 12 },
            { type: validatorTypes.MAX_LENGTH, threshold: 128 }
        ]
    },
    CONFIRM_PASSWORD: {
        component: componentTypes.TEXT_FIELD,
        name: 'confirmPassword',
        label: 'Re-Enter New Password',
        fieldType: 'password',
        validate: [
            { type: validatorTypes.REQUIRED },
            { type: validatorTypes.MIN_LENGTH, threshold: 12 },
            { type: validatorTypes.MAX_LENGTH, threshold: 128 }
        ],
        onPaste: (e: any) => {
            preventDefault(e);
        }
    },
    COMPANY_CODE: {
        component: componentTypes.TEXT_FIELD,
        name: 'code',
        label: 'Company Code',
        validate: [
            { type: validatorTypes.REQUIRED }
        ]
    },
    RESET_TOKEN: {
        component: componentTypes.TEXT_FIELD,
        name: 'resetToken',
        label: 'Reset Token',
        validate: [
            { type: validatorTypes.REQUIRED }
        ]
    }
}
